import firebase from "firebase";
import {UserAuthorization} from "./types";

const userAuthorizationDataConverter: firebase.firestore.FirestoreDataConverter<UserAuthorization> = {
    fromFirestore(snapshot: firebase.firestore.QueryDocumentSnapshot): UserAuthorization {
        return {
            role: snapshot.get('role')
        }
    },
    toFirestore(modelObject: UserAuthorization): firebase.firestore.DocumentData {
        return modelObject;
    }
}

export class AuthService {
    static GetCollection() {
        return firebase.firestore().collection('userRole').withConverter(userAuthorizationDataConverter);
    }

    async getUserAuthorization(userId: string): Promise<UserAuthorization> {
        const userAuthorizationSnapshot = await AuthService.GetCollection().doc(userId).get()
        if(!userAuthorizationSnapshot.exists) {
            throw new Error('User authorization not found')
        }
        return userAuthorizationSnapshot.data() as UserAuthorization
    }
}